import React from 'react';
import MeetMightyProSlider from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/MeetMightyProSlider/MeetMightyProSlider';
import LinkBrandedLarge from 'src/molecules/Standard/Shared/2024_Q3_profit_sales_redesign/LinkBrandedLarge/LinkBrandedLarge';
import IconsCallToActionArrow from 'src/images/IconsCallToActionArrow';
import {
  Content,
  MeetMightyProCTAWrapper,
  MeetMightyProTextBlock,
  Question,
  Title,
} from './MeetMightyProContent.styles';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import { ColorScheme } from 'src/styles/functions/getButtonStyleByColorScheme';

interface MeetMightyProContentProps {
  ctaColor: ColorScheme;
  sliderFullHeight: boolean;
}

const MeetMightyProContent = ({ ctaColor, sliderFullHeight = true }: MeetMightyProContentProps): JSX.Element => {
  return (
    <React.Fragment>
      <MeetMightyProTextBlock>
        <Question>
          <Heading
            text="And when you're ready to level up?"
            color={palette.cream}
            align='center'
            weight='normal'
            standardSize='2.5'
          />
        </Question>
        <Title>
          <Heading
            text='Meet Mighty Pro'
            color={palette.cream}
            align='center'
            standardSize={sliderFullHeight ? '3.375' : '5'}
            size={sliderFullHeight ? null : '5rem'}
          />
        </Title>
        <Content>
          <Paragraph
            text='On Mighty Pro, your Mighty Network is delivered on your own branded iOS and Android apps PLUS migration services and expert strategy.'
            color={palette.cream}
            align='center'
            weight='light'
            standardSize='1.5'
          />
        </Content>
      </MeetMightyProTextBlock>
      <MeetMightyProSlider fullHeight={sliderFullHeight} />
      <MeetMightyProCTAWrapper>
        <LinkBrandedLarge
          text='Explore Mighty Pro'
          url='/pro'
          size='1rem'
          sizeSm='0.875rem'
          customFontWeight={700}
          icon={
            <IconsCallToActionArrow
              color='greyText'
              width={15}
            />
          }
          colorScheme={ctaColor}
        />
      </MeetMightyProCTAWrapper>
    </React.Fragment>
  );
};

export default MeetMightyProContent;
